import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PlaceWiseHotelService from "../../services/placewisehotel.service";

// **Async Thunks**
export const addplacewiseHotel = createAsyncThunk(
  "placewiseHotel/addplacewiseHotel",
  async (item, thunkAPI) => {
    try {
      const response = await PlaceWiseHotelService.addplacewiseHotel(item);
      return response.data; // Return actual data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getplacewiseHotel = createAsyncThunk(
  "placewiseHotel/getplacewiseHotel",
  async (item, thunkApi) => {
    try {
      const response = await PlaceWiseHotelService.getplacewiseHotel(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


export const editplacewiseHotel = createAsyncThunk(
  "placewiseHotel/editplacewiseHotel",
  async (item, thunkAPI) => {
    try {
      const response = await PlaceWiseHotelService.editplacewiseHotel(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteplacewiseHotel = createAsyncThunk(
  "placewiseHotel/deleteplacewiseHotel",
  async (id, thunkAPI) => {
    try {
      await PlaceWiseHotelService.deleteplacewiseHotel(id);
      return id; // Return only the ID to remove it from state
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  placewiseHotels: [],
};

// **Slice**
const placewiseHotelSlice = createSlice({
  name: "placewiseHotel",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Car Type List**
      .addCase(getplacewiseHotel.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getplacewiseHotel.fulfilled, (state, action) => {
        state.loading = false;
        state.placewiseHotels = action.payload;
      })
      .addCase(getplacewiseHotel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      // **Handle Add Car Type**
      .addCase(addplacewiseHotel.pending, (state) => {
        state.loading = true;
      })
      .addCase(addplacewiseHotel.fulfilled, (state, action) => {
        state.loading = false;
        state.placewiseHotels.push(action.payload);
      })
      .addCase(addplacewiseHotel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Car Type**
      .addCase(editplacewiseHotel.pending, (state) => {
        state.loading = true;
      })
      .addCase(editplacewiseHotel.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.placewiseHotels.findIndex((c) => c.id === action.payload.id);
        if (index !== -1) {
          state.placewiseHotels[index] = action.payload;
        }
      })
      .addCase(editplacewiseHotel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete Car Type**
      .addCase(deleteplacewiseHotel.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteplacewiseHotel.fulfilled, (state, action) => {
        state.loading = false;
        state.placewiseHotels = state.placewiseHotels.filter((c) => c.id !== action.payload);
      })
      .addCase(deleteplacewiseHotel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default placewiseHotelSlice.reducer;
